/**
 * BagFast — Product Gallery
 * Thumbnail switching, image zoom on hover, and mobile swipe.
 */
(function () {
  'use strict';

  var gallery = document.querySelector('[data-product-gallery]');
  if (!gallery) return;

  var mainImage = gallery.querySelector('[data-gallery-main-img]');
  var mainWrap = gallery.querySelector('.product-gallery__main');
  var thumbs = gallery.querySelectorAll('[data-gallery-thumb]');

  /* ---- Thumbnail click ---- */
  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var src = this.getAttribute('data-gallery-thumb');
      if (!src || !mainImage) return;

      mainImage.setAttribute('src', src);
      mainImage.setAttribute('srcset', '');

      thumbs.forEach(function (t) {
        t.classList.remove('is-active');
      });
      this.classList.add('is-active');
    });
  });

  /* ---- Zoom on hover (desktop) ---- */
  if (mainWrap && mainImage) {
    mainWrap.addEventListener('mousemove', function (e) {
      if (window.innerWidth < 768) return;
      var rect = mainWrap.getBoundingClientRect();
      var x = ((e.clientX - rect.left) / rect.width) * 100;
      var y = ((e.clientY - rect.top) / rect.height) * 100;
      mainImage.style.transformOrigin = x + '% ' + y + '%';
      mainImage.style.transform = 'scale(2)';
    });

    mainWrap.addEventListener('mouseleave', function () {
      mainImage.style.transform = 'scale(1)';
      mainImage.style.transformOrigin = 'center center';
    });
  }

  /* ---- Mobile swipe ---- */
  if (mainWrap) {
    var images = [];
    thumbs.forEach(function (t) {
      images.push(t.getAttribute('data-gallery-thumb'));
    });

    if (images.length < 2) return;

    var currentIndex = 0;
    var touchStartX = 0;
    var touchEndX = 0;
    var threshold = 50;

    mainWrap.addEventListener(
      'touchstart',
      function (e) {
        touchStartX = e.changedTouches[0].screenX;
      },
      { passive: true }
    );

    mainWrap.addEventListener(
      'touchend',
      function (e) {
        touchEndX = e.changedTouches[0].screenX;
        var diff = touchStartX - touchEndX;

        if (Math.abs(diff) < threshold) return;

        if (diff > 0 && currentIndex < images.length - 1) {
          currentIndex++;
        } else if (diff < 0 && currentIndex > 0) {
          currentIndex--;
        }

        if (mainImage) {
          mainImage.setAttribute('src', images[currentIndex]);
        }

        thumbs.forEach(function (t, i) {
          t.classList.toggle('is-active', i === currentIndex);
        });
      },
      { passive: true }
    );
  }
})();
